import mod from "-!./edit_data_component.js?vue&type=script&lang=js&"; export default mod; export * from "-!./edit_data_component.js?vue&type=script&lang=js&"